import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const SendOrderAction = createAsyncThunk(
  "SendOrderAction",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/OrderAction",
        {
          Action: data1[0],
          OrderNo:data1[1],
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const OrderSlice = createSlice({
  name: "Order",
  initialState: {
    isLoading: "hide",
    isEmpty: "hide",
    isFilled: "",
    data: [],
    isError: "hide",
  },
 
  extraReducers: (builder) => {
    builder
      .addCase(SendOrderAction.fulfilled, (state, action) => {
        state.isLoading = "hide";
        state.isEmpty = "hide";
        state.isFilled = "";
        if (action.payload === "[NoDataFound]") {
          state.data = [];
          state.isEmpty = "";
          state.isFilled = "hide";
        } else {
          state.data = action.payload;
        }
        state.isError = "hide";
      })
      .addCase(SendOrderAction.pending, (state, action) => {
        state.isLoading = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isError = "hide";
      })
      .addCase(SendOrderAction.rejected, (state, action) => {
        state.isError = "";
        state.isEmpty = "hide";
        state.isFilled = "";
        state.isLoading = "hide";
      });
  },
});
 
export default OrderSlice.reducer;
